//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.TurningOperationBuilder.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
import "../CAM/CAM.ThreadCutParameters.js";
import "../CAM/CAM.NcmTurnThreadBuilder.js";
import "../CAM/CAM.CutAngle.js";
let d=[[[0,"CrestLine",1,"NXObject",0],[0,"CrestLineDirection",1,0],[1,"CrestOffset",0,"CAM.InheritableDoubleBuilder",0],[1,"CutParameters",0,"CAM.ThreadCutParameters",0],[0,"DepthOption",1,0],[0,"EndLine",1,"NXObject",0],[1,"EndOffset",0,"CAM.InheritableDoubleBuilder",0],[1,"FlankInfeedAngle",0,"CAM.InheritableDoubleBuilder",0],[1,"InfeedLength",0,"CAM.InheritableDoubleBuilder",0],[0,"InfeedLengthType",1,0],[0,"InfeedMethod",1,0],[0,"InfeedMode",1,0],[1,"InfeedMoveAngle",0,"CAM.InheritableDoubleBuilder",0],[1,"InfeedStartLineAngle",0,"CAM.InheritableDoubleBuilder",0],[0,"InputMode",1,0],[1,"NonCuttingBuilder",0,"CAM.NcmTurnThreadBuilder",0],[0,"RootLine",1,"NXObject",0],[1,"RootOffset",0,"CAM.InheritableDoubleBuilder",0],[0,"SelectedThread",1,0],[1,"StartOffset",0,"CAM.InheritableDoubleBuilder",0],[1,"ThreadAngleBuilder",0,"CAM.CutAngle",0],[0,"ThreadDirection",1,0],[0,"ThreadGeometry",1,"NXObject",0],[0,"ThreadGeometryFromTable",1,"NXObject",0],[0,"ThreadSize",1,0],[0,"ThreadStandard",1,0],[1,"TotalDepth",0,"CAM.InheritableDoubleBuilder",0]],[],[]];
SPLM.CAM.ThreadTurningBuilder = class extends SPLM.CAM.TurningOperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ThreadTurningBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ThreadTurningBuilder.InputModes = Object.freeze({
    "Manual" : "Manual", "ModelBased" : "ModelBased", "FromTable" : "FromTable"});

SPLM.CAM.ThreadTurningBuilder.ThreadDirections = Object.freeze({
    "Reverse" : "Reverse", "Forward" : "Forward"});

SPLM.CAM.ThreadTurningBuilder.InfeedMethods = Object.freeze({
    "RadialInfeed" : "RadialInfeed", "RearFlankInfeed" : "RearFlankInfeed", "FrontFlankInfeed" : "FrontFlankInfeed", "IncrementalInfeed" : "IncrementalInfeed"});

SPLM.CAM.ThreadTurningBuilder.InfeedModes = Object.freeze({
    "None" : "None", "Auto" : "Auto", "Specify" : "Specify"});

SPLM.CAM.ThreadTurningBuilder.InfeedLengthTypes = Object.freeze({
    "Auto" : "Auto", "Specify" : "Specify"});

SPLM.CAM.ThreadTurningBuilder.DepthOptionTypes = Object.freeze({
    "RootLine" : "RootLine", "DepthAndAngle" : "DepthAndAngle"});

export default SPLM;